import { CountryKey } from "./models/Common.model";

export const DATE_DATABASE = 'yyyy-MM-dd';
export const DATE_DISPLAY = 'dd-MM-yyyy';
export const DATETIME_DATABASE = 'yyyy-MM-ddT HH:mm:ss';
export const DATETIME_DISPLAY = 'dd-MM-yyyy HH:mm:ss';
export const langs: CountryKey[] = ["it", "fr", "es", "pt", "de", "pl", "tr", "be", "nl"];